<div class="row gy-3 gx-4">
  <div class="col-md-4 col-xl-3 col-xxl-2">
    <div class="card overflow-hidden border-0 shadow-sm mb-3 bg-light rounded-4 mb-3">
      <div class="card-header bg-white border-0 py-3">
        <h3 class="m-0">
          <i class="bi bi-info-circle me-1"></i>
          Lot Details
        </h3>
      </div>
      <div class="card-body bg-white pt-0">
        <div class="row gy-3 m-0">
          @if (specLot()) {
            <div class="col-12 mt-0 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Unit No.</label>
              <span class="text-muted">{{ specLot()!.lotNo }}</span>
            </div>

            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Type</label>
              <span class="text-muted">{{ specLot()!.lotTypeName }}</span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Status</label>
              <span class="text-muted">{{ specLot()!.statusName || '-' }}</span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Address</label>
              <span class="text-muted">
                @if (specLot()!.address) {
                  {{ specLot()!.address.streetNo }} {{ specLot()!.address.street }}
                  @if (specLot()!.address.street2) {
                    {{ specLot()!.address.street2 }}
                  }
                } @else {
                  -
                }
              </span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Release Date</label>
              <span class="text-muted">
                @if (specLot()!.finalSaleDate) {
                  {{ specLot()!.finalSaleDate | date: 'short' }}
                } @else {
                  -
                }
              </span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Legal Unit No.</label>
              <span class="text-muted">{{ specLot()!.legalUnit || '-' }}</span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Model</label>
              <span class="text-muted">
                @if (currentSelectedModel(); as selectedModel) {
                  {{ selectedModel.modelName }}
                } @else if (specLot()!.models && specLot()!.models.length > 0) {
                  {{ specLot()!.models[0].modelName }}
                } @else {
                  -
                }
              </span>
            </div>
            <div class="col-12 bg-light py-2 px-3 rounded-4">
              <label class="fw-500 d-block">Elevation</label>
              <span class="text-muted">
                @if (currentSelectedElevation(); as selectedElevation) {
                  {{ selectedElevation.elevationCode }}
                  @if (selectedElevation.description) {
                    - {{ selectedElevation.description }}
                  }
                } @else {
                  -
                }
              </span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-md">
    <h2 class="mb-4">
      <i class="bi bi-boxes me-2"></i>
      Model & Elevation
    </h2>
    <form [formGroup]="modelElevationForm">
      <div class="row gy-3">
        <div class="col-12 col-md-6 col-xl-3">
          <generic-dropdown
            [items]="modelsDropdownData()"
            [label]="'Model'"
            [placeholder]="'Select Model'"
            [required]="false"
            [allowSearch]="true"
            [clearable]="true"
            [formControl]="modelControl"
          >
          </generic-dropdown>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <generic-dropdown
            [items]="elevationsDropdownData()"
            [label]="'Elevation'"
            [placeholder]="'Select Elevation'"
            [required]="false"
            [allowSearch]="true"
            [clearable]="true"
            [formControl]="elevationControl"
          >
          </generic-dropdown>
        </div>
        <div class="col-auto align-self-end">
          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="btn btn-primary btn-h42"
              [disabled]="!isSaveEnabled() || isSaving()"
              (click)="saveChanges()"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
